import { DialogModule } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  PLATFORM_ID,
  ViewEncapsulation,
} from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router, RouterLink, RouterModule } from '@angular/router';
import { LoginService } from 'app/login.service';
import { Article } from 'app/models/Article';
import { MarketData } from 'app/models/MarketData';
import { Utilisateur } from 'app/models/Utilisateur';
import { ArticleSchemaService } from 'app/shared/ArticleSchema.service';
import { LinkService } from 'app/shared/Link.service';
import { ArticleService } from 'app/shared/article.service';
import { ConvertToSlugPipe } from 'app/shared/convert-to-slug.pipe';
import { DataService } from 'app/shared/data.service';
import { MetaService } from 'app/shared/meta.service';
import { SharedModule } from 'app/shared/shared.module';
import { UtilisateurService } from 'app/shared/utilisateur.service';
import { environment } from 'environments/environment';
import { QuillModule } from 'ngx-quill';
import { Subject, takeUntil } from 'rxjs';
export interface PeriodicElement {
  name: string;
  position: number;
  cours: number;
  variation: string;
  ouverture: string;
  haut: string;
  bas: string;
  titre: string;
  volume: string;
}

@Component({
  selector: 'app-actifs',
  templateUrl: './actifs.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatTableModule,
    MatIconModule,
    MatFormFieldModule,
    CommonModule,
    MatProgressBarModule,
    RouterLink,
    MatPaginatorModule,
    MatSelectModule,
    MatSidenavModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatButtonModule,
    DialogModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatDividerModule,
    MatInputModule,
    MatMenuModule,
    MatTooltipModule,
    SharedModule,
    MatRadioModule,
    QuillModule,
    MatBadgeModule,
    RouterModule,
  ],
})
export class ActifsComponent implements OnInit {
  dataArticles: Article[] = [];
  idUtilisateurConnecte: string = '';
  dataUtilisateurConnecte: Utilisateur;
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  serveur_name = environment.serveur_name;
  host_name = environment.host_name;

  displayedColumns: string[] = [
    'Nom Actif',
    'Cours',
    'Ouverture',
    '+ Haut',
    '+ Bas',
    'Titre',
    'Volume',
    'Variation',
  ];
  displayedColumns1: string[] = ['Indice', 'Valeur'];
  public dataSource = new MatTableDataSource<MarketData>();
  public dataSource1 = new MatTableDataSource<MarketData>();
  nbArticle: number;
  listeArticles: any;
  @Inject(PLATFORM_ID) private platformId: any;

  constructor(
    private utilisateurService: UtilisateurService,
    private articleService: ArticleService,
    private router: Router,
    private loginService: LoginService,
    private dataService: DataService,        private articleSchemaService: ArticleSchemaService,
    private _changeDetectorRef: ChangeDetectorRef,
    private seoService: LinkService, private metaService:MetaService
  ) {}

  ngOnInit(): void {
    this.dataService.recupererPrincipaux().subscribe((data: MarketData[]) => {
      this.dataSource.data = data;
    });
    this.dataService
      .recupererIndices()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (data: MarketData[]) => {
          let array: MarketData[] = ([] = data);
          const order = {
            TUNINDEX: 100,
            TUNINDEX20: 200,
            'AGROALIMENT BOISSO': 300,
            ASSURANCES: 400,
            BANQUES: 500,
            'BATIM MATE CONSTRU': 600,
            'BIENS CONSOMMATION': 700,
            DISTRIBUTION: 800,
            INDUSTRIES: 900,
            'MATERIAUX DE BASE': 1000,
            'PROD MENAGER SOIN': 1100,
            'SERVICES AUX CONSO': 1200,
            'SERVICES FINANCIER': 1300,
            'STES FINANCIERES': 1400,
          };
          array.sort(
            (a, b) =>
              order[a.referentiel.stockName] - order[b.referentiel.stockName],
          );
          this.dataSource1.data = array;
          this._changeDetectorRef.markForCheck();
        },
      });

    //this.chargerData();
    this.createLinkForCanonicalURL();
    this.metaService.updateMetaTags({
      title: 'Actifs',

    });
      // Générer les schémas structurés
        this.articleSchemaService.generateGlobalWebPageSchema({
          url: environment.apiUrl + '/actifs',
          name: 'Actifs',
          isPartOf: {
            name: 'Irbe7',
            url: environment.apiUrl,
          },
          description: 'Actifs'
        });
  }
  createLinkForCanonicalURL() {
    this.seoService.createLinkForCanonicalURL();
  }
  redirectFormation() {
    if (typeof window !== 'undefined') {
      const formationUrl = 'https://formation.irbe7.com/formations/';
      window.open(formationUrl, '_blank');
    }
  }

  redirectionMur(idActif, isinActif) {
    this.router.navigate(['/actifs', idActif, isinActif]);
  }

  truncateChar(text: string): string {
    let charlimit = 100;
    if (!text || text.length <= charlimit) {
      return text;
    }

    let without_html = text.replace(/<(?:.|\n)*?>/gm, '');
    let shortened = without_html.substring(0, charlimit) + '...';
    return shortened;
  }

  ngAfterViewInit() {}
  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
  appliquerFiltre(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    for (let i = 0; i < this.dataSource.data.length; i++) {
      this.dataSource.data[i]['name'] =
        this.dataSource.data[i].referentiel.stockName;
    }
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  chargerData() {
    if (this.loginService.getIsLogged()) {
      this.utilisateurService
        .getUtilisateurByUsername(this.loginService.getUsername())
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe({
          next: (dataUtilisateur: Utilisateur[]) => {
            this.dataUtilisateurConnecte = dataUtilisateur[0];
            this.idUtilisateurConnecte = this.dataUtilisateurConnecte.userId;
          },
        });
    }
    this.articleService
      .getArticles()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (dataArticles: Article[]) => {
          this.nbArticle = Object.keys(dataArticles).length;
          for (let i = 0; i < this.nbArticle; i++) {
            if (dataArticles[i].etat === 'VALIDE') {
              this.listeArticles = this.listeArticles || [];
              this.listeArticles.push(dataArticles[i]);
            }
          }
        },
      });
  }
}
